export function SearchBox() {

  const searchBox = document.querySelector('.search-section');
  if(searchBox){
    searchBox.querySelector('.tab__button:nth-child(1)').classList.add('tab__button--active');
    searchBox.querySelector('.tab__content:nth-child(1)').classList.add('tab__content--active');

    const tabs = searchBox.querySelectorAll('.tab__button');

    tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        const index = Array.from(tab.parentNode.children).indexOf(tab);
        const contents = searchBox.querySelectorAll('.tab__content');
        const buttons = searchBox.querySelectorAll('.tab__button');
        contents.forEach(content => content.classList.remove('tab__content--active'));
        buttons.forEach(button => button.classList.remove('tab__button--active'));
        contents[index].classList.add('tab__content--active');
        buttons[index].classList.add('tab__button--active');
      });
    });

    const openButton = searchBox.querySelector('.mobile-search-nav__open-button');
    const mobileSearchBlocks = searchBox.querySelector('.mobile-search-nav__blocks');
    
    openButton.addEventListener('click', (e) => {
      e.preventDefault();
      mobileSearchBlocks.classList.toggle('opened');
    });

    const designForm = searchBox.querySelector('.design-form');
    designForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const formData = new FormData(e.currentTarget);
      const color = formData.get('color') || '';
      const vibe = formData.get('vibe') || '';
      const queryAry = [];
      if(color) queryAry.push(color);
      if(vibe) queryAry.push(vibe);
      const query = queryAry.join(',');
      window.location.href = `${window.theme.blogURL}/products?design=${query}`;
    });

    const keywordForm = searchBox.querySelectorAll('.keyword-form');
    keywordForm.forEach(form => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const keyword = formData.get('s') || '';
        window.location.href = `${window.theme.blogURL}/products?s=${keyword}`;
      });
    });

  }
}